export function formatMoneyMinor(minor: number, currency = 'RUB'): string {
  return new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  }).format(Math.round(minor) / 100)
}

export function periodMonths(days: number): number {
  return ({ 30: 1, 90: 3, 180: 6, 365: 12 } as Record<number, number>)[days]
    || Math.max(1, Math.round(days / 30))
}

export function formatPeriodDays(days: number | null): string {
  if (!days) return 'Без ограничения'
  const known = ({ 30: '1 месяц', 90: '3 месяца', 180: '6 месяцев', 365: '12 месяцев' } as Record<number, string>)[days]
  return known || `${days} дней`
}

export function normalizePromoCode(value: string): string {
  return value.trim().toUpperCase().replace(/[^A-ZА-Я0-9_-]/g, '').slice(0, 64)
}

export function promoBenefit(promo: { bonus_days: number; discount_percent: number } | null): string {
  if (!promo) return ''
  if (promo.bonus_days === 30) return '+1 месяц в подарок'
  if (promo.bonus_days === 60) return '+2 месяца в подарок'
  if (promo.bonus_days > 0) return `+${promo.bonus_days} дней в подарок`
  return `−${promo.discount_percent}% по промокоду`
}
